import React from 'react';
import { FaCheck, FaTimes, FaChevronDown } from 'react-icons/fa';
import './Preferences.css';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Row, Col, Form, Select } from 'antd';
import { getLoy3AuthToken } from "selectors/authentication";
import { saveOrUpdateMember } from "actions/userProfileAction";
import { connect } from "react-redux";
import { getLoy3Profile } from "selectors/authentication";
import { setLanguage } from 'redux-i18n';

class Preferences extends React.Component {

  handleSubmit = e => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (!err) {
        this.props.saveOrUpdateMember(this.props.authToken, values);
      }
    });
  };

  handleLanguageChange = lang => {
    this.props.user.preferredLanguage = lang;
    this.props.user.profilePicture = this.props.user && this.props.user.profilePicture ? this.props.loy3Profile.profilePic.replace(/^.*[\\/]/, '') : "";
    this.props.saveOrUpdateMember(this.props.authToken, this.props.user);
    console.log(lang)
    this.props.dispatch(setLanguage(lang));
  };

  handleCurrencyChange = value => {
    this.props.user.preferredCurrency = value;
    this.props.user.profilePicture = this.props.user && this.props.user.profilePicture ? this.props.loy3Profile.profilePic.replace(/^.*[\\/]/, '') : "";
    this.props.saveOrUpdateMember(this.props.authToken, this.props.user);
  };
  handleHotelChange = value => {
    this.props.user.hotel = value;
    this.props.user.profilePicture = this.props.user && this.props.user.profilePicture ? this.props.loy3Profile.profilePic.replace(/^.*[\\/]/, '') : "";
    this.props.saveOrUpdateMember(this.props.authToken, this.props.user);
  };

  triggerChange = changedValue => {
    // Should provide an event to pass value to Form.
    const { onChange } = this.props;
    if (onChange) {
      onChange(Object.assign({}, this.state, changedValue));
    }
  };

  handleChange = (field, value) => {
    this.setState({ [field]: value });
  };

  render() {

  
    const { registrationInfo } = this.props;
    const { user } = this.props;

    if (!user || !registrationInfo) {
      return null;
    }
    const { getFieldDecorator } = this.props.form;
    const { Option } = Select;
    const selectedLanguage = registrationInfo && registrationInfo.languageTo && user && registrationInfo.languageTo.find(languageObj => languageObj.locale === user.preferredLanguage);
    const selectedCurrency = registrationInfo && registrationInfo.currencyTo && user && registrationInfo.currencyTo.find(currencyObj => currencyObj.currencyId === user.preferredCurrency);
    const selectedHotel = registrationInfo && registrationInfo.hotelsList && user && registrationInfo.hotelsList.find(hotelObj => hotelObj.hotelId === user.hotel);

    return (
      <div className="preferences-container">
        <h1>{this.context.t('PREFERENCES')}</h1>
        <div className="preference-group">
          <label>{this.context.t('Language')} *</label>
          <div className="select-wrapper">
            <select
              value={user.preferredLanguage || ''}
              onChange={(e) => this.handleLanguageChange(e.target.value)}
              required
              className="underline-select"
            >
              {/* <option value="">{this.context.t('Please select your language')}</option> */}
              {registrationInfo.languageTo?.map((language) => (
                <option key={language.locale} value={language.locale}>
                  {language.language}
                </option>
              ))}
            </select>
            <div className="icons-container">
              <FaChevronDown className="chevron-icon" />
              {user.preferredLanguage ? (
                <FaCheck className="icon check-icon" />
              ) : (
                <FaTimes className="icon times-icon" />
              )}
            </div>
          </div>
        </div>

        <div className="preference-group">
          <label>{this.context.t('Currency')}</label>
          <div className="select-wrapper">
            <select
              value={user.preferredCurrency || ''}
              onChange={(e) => this.handleCurrencyChange(e.target.value)}
              className="underline-select"
            >
              {/* <option value="">{this.context.t('Please select')}</option> */}
              {registrationInfo.currencyTo?.map((currency) => (
                <option key={currency.currencyId} value={currency.currencyId}>
                  {currency.currencyName}
                </option>
              ))}
            </select>
            <div className="icons-container">
              <FaChevronDown className="chevron-icon" />
              {user.preferredCurrency ? (
                <FaCheck className="icon check-icon" />
              ) : (
                <FaTimes className="icon times-icon" />
              )}
            </div>
          </div>
        </div>

        <div className="preference-group">
          <label>{this.context.t('Hotel')}</label>
          <div className="select-wrapper">
            <select
              value={user.hotel || ''}
              onChange={(e) => this.handleHotelChange(e.target.value)}
              className="underline-select"
            >
              {/* <option value="">{this.context.t('Please select')}</option> */}
              {registrationInfo.hotelsList?.map((hotel) => (
                <option key={hotel.hotelId} value={hotel.hotelId}>
                  {hotel.hotelName}
                </option>
              ))}
            </select>
            <div className="icons-container">
              <FaChevronDown className="chevron-icon" />
              {user.hotel ? (
                <FaCheck className="icon check-icon" />
              ) : (
                <FaTimes className="icon times-icon" />
              )}
            </div>
          </div>
        </div>
      </div>
    );

  }
}

Preferences.propTypes = {
  user: PropTypes.object,
  saveOrUpdateMember: PropTypes.func.isRequired
};

Preferences.contextTypes = {
  t: PropTypes.func.isRequired,
};


const mapStateToProps = (state) => ({
  authToken: getLoy3AuthToken(state),
  loy3Profile: getLoy3Profile(state),
});


const mapDispatchToProps = (dispatch) => ({
  dispatch,
  saveOrUpdateMember: (authToken, values) => saveOrUpdateMember(authToken, values)(dispatch)
});


Preferences = connect(
  mapStateToProps,
  mapDispatchToProps
)(Preferences);

const WrappedRegistrationForm = Form.create({ name: 'preferencesForm' })(Preferences);
export default WrappedRegistrationForm;

//export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Preferences));
